import React from 'react';
import Form from 'react-bootstrap/Form';



function MissingFirstNameForm (props) {
    return (
        <Form.Group id = "createFirstNameGroupSocial"  className= "relative">
                <Form.Label className = {`${props.floatFirstName === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${props.firstNameFocus === true ? "label-black__TO" : "" }
                                        ${props.isFirstNameValid === false && props.firstNameFocus === false ? "label-red__TO" : ""}
                `} >
                    First Name<span id="redStar">*</span></Form.Label>
                <Form.Control
                required
                id = "createFirstName__TO"
                data-testid = "createFirstName"
                aria-label = "First Name"
                as = "input"
                type = "text"
                name = "firstname"
                value = {props.firstName}
                onChange = {props.handleFirstNameChange}
                onFocus = {props.setFocusFirstName}
                onBlur = {props.onBlurFirstName}
                bsPrefix = {`${props.isFirstNameValid === false && props.firstNameFocus === false ? "highlight-error__TO form-control" : ""}`}

            />
            <div
                id = "createFirstNameAlert" 
                data-testid = "createFirstNameError" 
                className = {`logon-item-error__TO ${props.isFirstNameValid === false && props.firstNameFocus == false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${props.isFirstNameValid === false && props.firstNameFocus === false ? "false" : "true"}`}
            >
                Your first name must be between 1 and 14 characters. It can include spaces, apostrophes, and hyphens.
            </div>
        </Form.Group>
    )
}

export default MissingFirstNameForm;